// Vendored from gs-ui-templates/src/components/Tooltip/index.tsx, with the design
// system import swapped per rule 2 (old gs-react-ui package -> gupshup-ts-components).
// theme.custom.colors.purple[400] resolves from the library's own default theme
// (confirmed in its ThemeProvider bundle), not from GUPSHUP_THEME_CONFIG, so this needs
// no extra theme wiring in bloomreach-ui.
import { useTheme, Tooltip as TsTooltip } from '@gupshup-frontend/gupshup-ts-components';

const Tooltip = (props) => {

  const { children } = props;

  const theme = useTheme();

  return (
    <TsTooltip
      arrow      = {true}
      bgColor    = {theme.custom.colors.purple[400]}
      arrowColor = {theme.custom.colors.purple[400]}
      styles     = {{color: theme.palette.common.white}}
      {...props}
    >
      {children}
    </TsTooltip>
  );

};

export default Tooltip;
